import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'brand_leads-brands_form_product_type-click';

/**
 * Focus on product type selector field in brands sign up form
 */
export function trackBrandLeadsBrandsFormProductTypeClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
